module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/images/tab-bg.df50953d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/images/tab-bg.png
// module id = 3101
// module chunks = 11